import { useMediaQuery } from 'react-responsive';

import { sizes } from '../../theme/device';

import Tooltip from '../Tooltip';

type Props = {
  children: any;
  [x: string]: any;
};

function TooltipWrapForSmallScreens({ children, ...rest }: Props) {
  // maxWidth needs -1px or 1px of the media query goes unapplied (same in MainContent).
  // TODO: Rework media query resizing values to not have this hack.
  const isBelowLaptopL = useMediaQuery({
    maxWidth: sizes.laptopL - 1,
  });

  if (isBelowLaptopL) {
    return <Tooltip {...rest}>{children}</Tooltip>;
  }

  return children;
}

export default TooltipWrapForSmallScreens;
